module.exports = __WEBPACK_EXTERNAL_MODULE_48__;


//////////////////
// WEBPACK FOOTER
// external {"root":"d3","commonjs2":"d3","commonjs":"d3","amd":"d3"}
// module id = 48
// module chunks = 0